import { DOMHelpers } from "helpers/dom";
import { IWCCContentBlock } from "./blocks/block/block.interfaces";
import { WCCContentNodeBlock, WCCContentNodeBlockOptions } from "./blocks/node/node";
import { WCCContentTextBlock } from "./blocks/text/text";

export module WCCContentHelpers {
    export function getBlockFromNode(node: Node, options?: WCCContentNodeBlockOptions): IWCCContentBlock {
        const {
            isProtected = false,
            noTrim = false
        } = options ?? {};

        if (DOMHelpers.isText(node) && !isProtected)
            return new WCCContentTextBlock({ content: node.textContent ?? '', noTrim });
        else
            return new WCCContentNodeBlock(node, undefined, { isProtected, noTrim });
    }
}